<ng-container *ngIf="!loading; else loadingTemplate">
  <ng-container *ngIf="!error; else errorTemplate">
    <ng-container *ngIf="shortlistItems?.length; else emptyTemplate">
      <div class="container">
        <div class="header">
          <div class="title">
            <span class="copy">Wish List</span>
            <div class="badge">
              <span>{{ shortlistItems.length }} {{ shortlistItems.length === 1 ? "Item" : "Items" }}</span>
            </div>
          </div>
          <div class="subtitle">
            <mat-icon svgIcon="help"></mat-icon>
            <span class="copy">We'll load these items into 3D so you can use them throughout the Showroom.</span>
          </div>
        </div>
        <div class="body merri-scrollbar-gray">
          <div class="items">
            <div
              class="item"
              *ngFor="let item of shortlistItems; index as i"
            >
              <div class="image">
                <img
                  [src]="item.thumbnailImageUrl"
                  imgErrLog
                />
                <button
                  mat-icon-button
                  class="button-zoom"
                  (click)="onShortlistItemZoomClick(item); $event.stopPropagation()"
                >
                  <mat-icon svgIcon="zoom_in"></mat-icon>
                </button>
              </div>
              <div class="content">
                <div class="item-info">
                  <span class="sku-name">{{ item.skuName }}</span>
                </div>
                <div class="controls">
                  <button
                    mat-icon-button
                    (click)="onDeleteClick(item, i)"
                  >
                    <mat-icon svgIcon="delete"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <button
            mat-flat-button
            color="primary"
            class="merri-common-button-bold"
            (click)="onInquireNowClick()"
          >
            Inquire
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <merri-loading-spinner
      class="button-spinner"
      [loading]="true"
      [color]="primary"
    ></merri-loading-spinner>
  </div>
</ng-template>

<ng-template #errorTemplate></ng-template>

<ng-template #emptyTemplate>
  <div class="empty-container">
    <div class="icon">
      <mat-icon svgIcon="favorite_outline"></mat-icon>
    </div>
    <div class="content">
      <div class="title">Welcome to your Wish List</div>
      <div class="copy">
        Add items as you discover them in the showroom. Your Wish List items will be ready for you when you want to add them to the table or
        floor designs.<br /><br />
        You can use the items in your Wish List to customize your design. You can also send your Wish List to
        {{ data.showroom.ownerName }} to get the latest information.
      </div>
    </div>
  </div>
</ng-template>
